import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { setLoading, saveData } from './actions';
import PaymentDetails from './component';

class PaymentDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // fetch all the permissions
    this.props.setLoading(true);

    const orderId = this.props.match.params.orderId;
    // alert(orderId);
    if (!orderId) {
      toastr.error('ERROR', 'Invalid Order Id');
      return this.props.history.push('/orders_search');
    }

    this.props.getDataFromAPI(
      `/payments/orders/${orderId}`,
      'GET',
      undefined,
      (response) => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      (err) => {
        this.props.setLoading(false);
        toastr.error('ERROR', err.data.message);
        // console.log(err);
      },
      true
    );
  }

  render() {
    const details =
      this.props.paymentDetails &&
      this.props.paymentDetails.details &&
      this.props.paymentDetails.details.result;
    const loading = this.props.paymentDetails && this.props.paymentDetails.loading;
    const orderId = this.props.match.params.orderId;

    console.log({ paymentDetails: details });

    return <PaymentDetails orderId={orderId} loading={loading} details={details} />;
  }
}

function mapStateToProps({ paymentDetails }) {
  return {
    paymentDetails
  };
}

export default withRouter(connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
  saveData
})(PaymentDetailsContainer));



// WEBPACK FOOTER //
// ./src/Modules/PaymentDetails/container.jsx